import ComponentHeader from '../main/ComponentHeader';
import GruntComponents from '../components';
import {Box,  SkeletonCircle, SkeletonText,
    useToast,Input,InputGroup,InputLeftElement
      } from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import PopisGovedaTable from './PopisGovedaTable';
import { getPopise,deletePopis } from '../../util/apiMRgg';
import PopisGovedaDetail from './PopisGovedaDetail';
import { SearchIcon } from '@chakra-ui/icons';


export default function PopisiGoveda({onClosePress,size='xs'}) {
  const [popis,setPopis]=useState({data:[],prikaz:[],filter:"",fetchfilterdata:false});
  const [rggid,setRggId]=useState(-1);
  const [dataIsFetching,setDataIsFetching]=useState(false);
  const [fetchdata,setFetchData]=useState(true);
  const [msg,setMsg]=useState({msgType:"",message:""});
  
  const toast=useToast();
  //const userCanEdit=lp.uloga==="r"?false:true;
  //
  useEffect(() => {
    const fetchPopis=async()=>{
      setDataIsFetching(true);
      try {
        const res=await getPopise();
        if (res.status===200) {
          setPopis({...popis,data:res.res,prikaz:res.res});
        } else {
          throw new Error(res.message);
        }
      } catch (error) {
        toast({
          title:"Greška kod dohvata podataka.",
          status:"error",
          description:error.message,
          isClosable:true,
          duration:2000,
          position:"top-right",
      });
      } finally {
        setDataIsFetching(false);
      }
    }
    fetchPopis();
  }, [fetchdata])
  
  
  useEffect(() => {
    const fetchPopisByFilter=async()=>{
      setDataIsFetching(true);
      try {
        
        const res=await getPopise(popis.filter);
        if (res.status===200) {
          setPopis({...popis,data:popis.data,prikaz:res.res});
        } else {
          throw new Error(res.message);
        }
      } catch (error) {
        toast({
          title:"Greška kod dohvata podataka.",
          status:"error",
          description:error.message,
          isClosable:true,
          duration:2000,
          position:"top-right",
      });
      } finally {
        setDataIsFetching(false);
      }
    }
    if (popis.filter!=="") {
      fetchPopisByFilter();  
    }
    
  }, [popis.fetchfilterdata])

  const selectPopis=(id)=>{
    setRggId(id);
  }

  const handleDeletePopis=async (_rggid)=>{
    let _msg="";
    try {
      const _res=await deletePopis(_rggid);
      if (_res.status!==200) {
        _msg=_res.message;
      } else {
        setRggId(-1);
        setFetchData(!fetchdata);
      }
    } catch (error) {
      _msg=error.message;
      
    } finally {
      if (_msg==="") {
        setMsg({...msg,msgType:"success",message:"Popis uspješno obrisan."})
        
      } else {
        setMsg({...msg,msgType:"error",message:_msg});
      }
    }
    
    
  }

  const showMessage=()=>{
    if (msg.msgType!=="") {
      
      toast({
        title:"RGG",
        status:msg.msgType,
        description:msg.message,
        isClosable:true,
        duration:2500,
        position:"top-right",
    });
    setMsg({...msg,msgType:"",message:""});
    }
  }
  const getSearchBox=()=>{
    return (
        <>
            <InputGroup size={'xs'} w={'30rem'} alignContent={'center'} >
              <InputLeftElement h={'full'} pointerEvents={'none'} children={<SearchIcon/>}></InputLeftElement>
              <Input focusBorderColor='grunt2.400' value={popis.filter} onKeyDown={handleKeyDown}  onChange={handleFilter} variant={'outline'} placeholder={'*=više znakova/_ =jedan znak/Enter =pretraga po životnom broju'} w={'1000%'}></Input>
            </InputGroup>
            
        </>
    )
}
const handleKeyDown=(e)=>{
  if (e.key==='Enter') {
    const _rgzivbrtest=/^(\w{2}\ ?|\*|\_)(\d+|\*|_)*$/;
    const _r=new RegExp(_rgzivbrtest);
    if (_r.test(popis.filter)) {//upisan životni broj-pokreći pretragu ako je dužina veća od 5
        //pozovi pretragu na serveru
        setPopis({...popis,fetchfilterdata:!popis.fetchfilterdata});
    } 
  }
}
const handleFilter=(e)=>{
     
  const _val0=e.target.value.toUpperCase();
  let _ar=[];
  if (_val0==="") {
    _ar=[...popis.data];
  } else {

  
      const _val=_val0.replaceAll("_",".").replaceAll("*",".*");  
      const _rgxstr="^.*" + _val+".*$"; 
      const _r=new RegExp(_rgxstr);
      
      
      _ar=popis.data.filter((item)=>{
          return ((_r.test(item.lokacija.toUpperCase()) || _val0==="") || (_r.test(item.toviliste.toUpperCase()) || _val0==="") || (_r.test(item.odjeljak.toUpperCase()) || _val0==="") ||
          (_r.test(item.naziv.toUpperCase()) || _val0==="") || (_r.test(item.operater.toUpperCase()) || _val0===""))
      })

  }
  
 setPopis({...popis,prikaz:_ar,filter:_val0});
  
}
  const buildScreen=()=>{
    if (dataIsFetching) {
      return (
        <Box display={'flex'} flexDir={'column'} gap={'0.5rem'} w='100%'>
          
                <SkeletonCircle size='10' />
                <SkeletonText mt='4' noOfLines={30} spacing='3' skeletonHeight='2' />
            
        </Box>
      )
    } else {
      if (rggid===-1) {
        return (
          <>
          <ComponentHeader onClosePress={onClosePress} component={GruntComponents.PopisGoveda}/>
          <Box display={'flex'} flexDir={'column'} alignItems={'center'} flex='1'>
            <Box display={'flex'} flexDir={'row'} width={'100%'} mb={'0.5rem'}>
              {getSearchBox()}
            </Box>
            
                    <PopisGovedaTable popisGoveda={popis.prikaz} readonly={false} onSelectPopis={selectPopis}/>
          </Box>
          </>
        )  
      } else {
        return (
          <>
            <ComponentHeader onClosePress={()=>setRggId(-1)} component={GruntComponents.PopisGovedaDetail}/>
            <Box display={'flex'} flexDir={'column'} alignItems={'center'} flex='1'>
              <PopisGovedaDetail rgg_id={rggid} onCreateSpecifikacija={()=>setFetchData(!fetchdata)} onClose={()=>setRggId(-1)} onDelPopis={handleDeletePopis} />
            </Box>
          </>
        )
      }
      	
    }
  }



  

  
  return (
    <Box  display={'flex'} flexDir={'column'} h={'100%'} key='odlasci_component' pl='0.5rem' pr={'0.5rem'} borderWidth={'1px'} borderColor={'silver'} borderBottomRightRadius={'md'}>
       
        
        
        {buildScreen()}
        {showMessage()}
     
    </Box>
  )
}
